import { gql } from '@apollo/client';

export const SHOPPING_LIST_PROMO_AND_CABLE_SNAP_SKUS = gql`
    query AllPersonalizedSaleProducts($sid: String) {
        getAllPersonalizedSaleSkus(sid: $sid) {
            hits {
                id
                position
                sku
                productName
                ean
                supplierId
                supplierName
                productCocontractor
                image
                salesUnit
                packagingSize
                quantityUnit
                hasAccessories
                hasAlternatives
                isPromotion
                bonus
                customerArticleNumber
                scoreCardIndex
                fiveYearGuarantee
                supplierProductNumber
                cableSnaps {
                    chargeNr
                    length
                }
            }
            notFound
        }
    }
`;
